import {BaseThunkType, InferActionTypes} from "../index";
import {Locale} from "antd/lib/locale-provider";
import ruRU from 'antd/lib/locale/ru_RU'
//import byBY from 'antd/lib/locale/by_BY'
//import enUs from 'antd/lib/locale/en_US'

let initialState = {
    lang: ruRU as Locale,
}

export type InitialStateType = typeof initialState;

const lang = (state = initialState, action: ActionsType): InitialStateType => {
    switch (action.type) {
        case 'MB/LOCALE/SET_LANG':
            return {
                ...state,
                lang: action.lang
            }
        default:
            return state;
    }
}

export const actions = {
    setLanguage: (lang: Locale) => ({
        type: 'MB/LOCALE/SET_LANG', lang
    } as const)
}
type ActionsType = InferActionTypes<typeof actions>
type ThunkType = BaseThunkType<ActionsType>

export const setLanguage = (lang: Locale): ThunkType => async (dispatch) => {
    dispatch(actions.setLanguage(lang));
}

export default lang;